module.exports = "https://cdn.dove.it/_next/static/public/assets/come-funziona-consulenza.a9adf80764ffa3aefe5e4e6503d8420a.png";